'use strict';
window.Nacl = window.Nacl || {};

/**
 * Lightweight popup. Call Nacl.LitePopup.apply(someElementOrSelector).  The "context" of a popup is
 * the closest parent elementOrSelector.
 * 
 * * data-lwpopup-toggle="selector": Toggles visiblity of all $('selector') elements in the context.
 * * data-lwpopup-close: If present inside the popup, closes the popup
 * 
 * When a popup is made visible, it can be hidden by a click anywhere on the page except
 * on the element itself.
 */
window.Nacl.LitePopup = (function($) {
  var isIos = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
  var clickEvent = (isIos) ? "touchstart" : "click";
  
  function showPopup($popup) {
    var showClass = $popup.attr('data-lwpopup-showClass');
    if (showClass) { $popup.addClass(showClass); }
    else { $popup.show(); }
    
    var handler = $popup.attr('data-lwpopup-onopen');
    
    if (handler) {
      var result = eval(handler);
      if (result) { result.bind($popup[0]).call(); }
    }
  }

  function hidePopup($popup) {
    var showClass = $popup.attr('data-lwpopup-showClass');
    if (showClass) { $popup.removeClass(showClass); }
    else { $popup.hide(); }

    var handler = $popup.attr('data-lwpopup-onclose');
    
    if (handler) {
      var result = eval(handler);
      if (result) { result.bind($popup[0]).call(); }
    }
  }

  function apply(selector) {
    var $container = $(selector);
    var $body = $('body');
    
    $container.find('[data-lwpopup-toggle]').each((idx, el) => {
      var $toggleBtn = $(el);
      var popupSelector = $toggleBtn.attr('data-lwpopup-toggle');
      var $popup = $(popupSelector, $container);
      
      $popup.find('[data-lwpopup-close]').on(clickEvent, () => hidePopup($popup));
      
      $toggleBtn.on(clickEvent, (eClick) => {
        eClick.stopPropagation();
        
        if (!$popup.is(':visible')) {
          showPopup($popup);

          // Function to clear the popup on any clicks that happen outside it.
          var fnRemover = (eRm) => {
            if (!$popup.is(':visible')) { return; }

            var target = eRm.originalEvent.target;
            
            var clickWasInPopup = !!$popup.has(target).length;

            // The click is outside the popup
            if (!clickWasInPopup) {
              hidePopup($popup);
              $body.off(clickEvent, fnRemover);
            }
          };
          
          $body.on(clickEvent, fnRemover);
        }
        else {
          hidePopup($popup);
        }
      });
    });
  }
  
  return {
    apply: apply
  }
})(jQuery);

